<template>
  <button
    class="cart-button"
    @click="handleAddToCart"
    :disabled="clicked || disabled"
    :class="{ clicked: clicked, disabled: disabled }"
  >
    <div class="image" :class="{ clicked: clicked }">
      <inline-svg
        class="paper"
        :class="{ clicked: clicked }"
        src="/images/cart-button/paper.svg"
      ></inline-svg>
      <inline-svg
        class="plus"
        :class="{ clicked: clicked }"
        src="/images/cart-button/plus.svg"
      ></inline-svg>

      <inline-svg
        class="cart"
        src="/images/cart-button/cart-r.svg"
      ></inline-svg>
    </div>
    <span class="cart-text" :class="{ clicked: clicked }">In winkelwagen</span>
    <span class="done-text" :class="{ clicked: clicked }">Toegevoegd</span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false
    }
  },
  methods: {
    handleAddToCart() {
      this.clicked = true
      this.$emit('add-to-cart')
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-button {
  background-color: var(--arch-color);
  color: var(--arch-text-color);
  border-radius: 23px;
  padding: 0;
  //width: 210px;
  height: 45px;
  //color: #4f4f4f;
  font-weight: 600;
  font-size: 0.82rem;
  transition: 0.2s;
  position: relative;
  overflow: hidden;
  width: 100%;

  container-type: inline-size;

  span {
    display: none;
  }

  @container (width > 130px) {
    span {
      display: inline-block;
      padding-left: 10px;
    }
  }

  span {
    vertical-align: middle;
  }
  &:hover:not(.disabled) {
    box-shadow: var(--default-shadow);
  }

  &.disabled {
    opacity: 0.4;
    cursor: default;
  }

  &.clicked {
    .plus {
      animation: plus 0.2s ease-in forwards;
    }

    .paper {
      animation: box 0.25s ease-in forwards;
    }
  }
}

.image {
  display: inline-block;
  position: relative;

  &.clicked {
    animation: cart 0.7s ease-out 0.35s forwards;
  }
}
.paper {
  position: absolute;
  top: -26px;
  left: 8px;

  :deep(g) {
    stroke: var(--arch-text-color);
  }
}

.plus {
  position: absolute;
  left: 8px;
  :deep(g) {
    fill: var(--arch-text-color);
  }
  /*   &.clicked {
    animation: plus 0.2s ease-in forwards;
  } */
}

.cart {
  vertical-align: middle;

  :deep(circle) {
    fill: var(--arch-text-color);
  }

  :deep(polyline) {
    stroke: var(--arch-text-color);
  }
}

.cart-text {
  opacity: 1;
  transition: opacity 0.4s 0.25s;
  color: var(--arch-text-color);
  &.clicked {
    opacity: 0;
  }
}

.done-text {
  color: var(--arch-text-color);
  opacity: 0;
  transition: opacity 0.4s 0.8s;
  position: absolute;
  left: 67px;
  top: 15px;
  &.clicked {
    opacity: 1;
  }
}

@keyframes box {
  0% {
    top: -26px;
  }

  90% {
    top: 3px;
  }

  100% {
    top: -3px;
  }
}

@keyframes plus {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes cart {
  0% {
    left: 0px;
    transform: rotate(0deg);
  }

  10% {
    left: -10px;
  }

  15% {
    transform: rotate(-20deg);
  }
  100% {
    left: 180px;
  }
}
</style>
